import { css } from "@/styled-system/css";
const formFieldWrapper = css.raw({
  display: "flex",
  gap: "md",
  flexDirection: "column",
  marginTop: "xs"
});
const sliderLabel = css({
  display: "block",
  marginBottom: "token(spacing.200)"
});
const gridWithMargin = css.raw({
  display: "grid",
  margin: "32px 10px 10px 15px"
});
const gridWithPadding = css.raw({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  paddingTop: "6px"
});
const gridEnd = css.raw({
  display: "grid",
  justifySelf: "end"
});
const styledSlider = css({
  width: "100%",
  height: "token(sizes.600)",
  maxWidth: "40.625rem"
});
const thumb = css({
  height: "token(sizes.900)",
  width: "token(sizes.900)",
  backgroundColor: "token(colors.white)",
  borderRadius: "token(radii.ellipse)",
  border: "2px solid token(colors.blue.500)",
  cursor: "ew-resize",
  outline: "none",
  "&:focus": {
    boxShadow: "token(shadows.focus)"
  },
  "& .upper-tooltip": {
    background: "token(colors.gray.800)",
    width: "token(sizes.2000)",
    height: "token(sizes.600)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "token(radii.150)",
    color: "token(colors.white)",
    fontSize: "token(fontSizes.350)",
    left: "-1.5625rem",
    position: "absolute",
    top: "-2.1875rem"
  }
});
const trackActive = css({
  top: "auto",
  bottom: 0,
  borderRadius: "token(radii.400)",
  boxShadow: "inset 0 0 token(sizes.75) token(colors.gray.800)",
  height: "token(sizes.400)",
  backgroundColor: "token(colors.blue.500)"
});
const trackInactive = css({
  top: "auto",
  bottom: 0,
  borderRadius: "token(radii.400)",
  boxShadow: "inset 0 0 token(sizes.75) token(colors.gray.800)",
  height: "token(sizes.400)",
  backgroundColor: "token(colors.gray.200)"
});
export {
  formFieldWrapper,
  gridEnd,
  gridWithMargin,
  gridWithPadding,
  sliderLabel,
  styledSlider,
  thumb,
  trackActive,
  trackInactive
};
